import { useEffect, useState } from 'react';

export const mediumScreenSize = 1024;
export const smallScreenSize = 768;

export const useIsSmallScreen = (maxWidth: number = smallScreenSize) => {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= maxWidth);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [maxWidth]);

  return isSmallScreen;
};
